module.exports = __webpack_public_path__ + "img/bg_main0201.310234c2.png";